import aa from 'search-insights';

// 共用的 Algolia Insights 工具：供結果頁 grid 點擊（及後續 conversion）送事件
// 事件走獨立的 insights.algolia.com，不計入 search requests（不額外計費）

const POST_INDEX = 'Post';
let initialized = false;

function ensureInit() {
  if (initialized) return;
  const appId = window.global_values && window.global_values.ALGOLIA__APP_ID;
  const apiKey = window.global_values && window.global_values.ALGOLIA__API_SEARCH_KEY;
  if (!appId || !apiKey) return;
  // search-insights 為匿名使用者自動管理 userToken（_ALGOLIA cookie），與 autocomplete 共用
  aa('init', { appId, apiKey });
  initialized = true;
}

ensureInit();

/**
 * 送出「搜尋後點擊」事件（clickedObjectIDsAfterSearch）。
 * 缺 queryID / objectID / position 任一就靜默略過（非搜尋來源的列表不會送）。
 *
 * @param {object} params
 * @param {string} params.queryID - 來自 /api/v1/posts 回應的 query_id
 * @param {number|string} params.objectID - post id
 * @param {number} params.position - 1-based 顯示位置
 * @param {string} [params.eventName='Post Clicked After Search']
 */
export function clickedPostAfterSearch({ queryID, objectID, position, eventName = 'Post Clicked After Search' }) {
  if (!queryID || objectID == null || !position) return;
  ensureInit();
  if (!initialized) return;

  aa('clickedObjectIDsAfterSearch', {
    eventName,
    index: POST_INDEX,
    queryID,
    objectIDs: [String(objectID)],
    positions: [position],
  });
}

export { aa };
